var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUilHeartAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.28 3.26542C13.528 2.51317 12.531 2.05581 11.4702 1.97652C10.4095 1.89723 9.35555 2.20126 8.50003 2.83333C7.59879 2.16299 6.47703 1.85903 5.36064 1.98265C4.24426 2.10627 3.21618 2.6483 2.48343 3.49958C1.75068 4.35086 1.3677 5.44816 1.4116 6.57051C1.4555 7.69286 1.92303 8.75689 2.72003 9.54833L7.99712 14.8254C8.06296 14.8918 8.14131 14.9445 8.22762 14.9805C8.31394 15.0164 8.40652 15.0349 8.50003 15.0349C8.59354 15.0349 8.68612 15.0164 8.77244 14.9805C8.85876 14.9445 8.9371 14.8918 9.00295 14.8254L14.28 9.54833C14.6927 9.13589 15.0201 8.64616 15.2435 8.10713C15.4669 7.56811 15.5819 6.99035 15.5819 6.40687C15.5819 5.8234 15.4669 5.24564 15.2435 4.70662C15.0201 4.16759 14.6927 3.67786 14.28 3.26542ZM13.2813 8.54958L8.50003 13.3237L3.71878 8.54958C3.29745 8.12649 3.01043 7.58841 2.89374 7.00282C2.77704 6.41724 2.83587 5.81023 3.06283 5.25795C3.2898 4.70567 3.67479 4.23271 4.16953 3.8984C4.66426 3.56409 5.2467 3.38331 5.84378 3.37875C6.64145 3.3807 7.40573 3.69915 7.96878 4.26417C8.03463 4.33056 8.11297 4.38325 8.19929 4.41921C8.28561 4.45518 8.37819 4.47369 8.4717 4.47369C8.56521 4.47369 8.65779 4.45518 8.74411 4.41921C8.83042 4.38325 8.90877 4.33056 8.97462 4.26417C9.55426 3.76188 10.3031 3.49856 11.0695 3.52752C11.836 3.55647 12.5628 3.87554 13.1029 4.42013C13.643 4.96473 13.956 5.69418 13.9786 6.46084C14.0012 7.22751 13.7317 7.97413 13.2246 8.54958H13.2813Z",
    fill: "url(#paint0_linear_293_1455)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_293_1455",
    x1: 1.4082,
    y1: 1.95566,
    x2: 14.4454,
    y2: 16.0837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1389FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB4E7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUilHeartAlt);
export default __webpack_public_path__ + "static/media/uil_heart-alt.5bcca2f0ad1c93b7fef0fe1a04c92b1a.svg";
export { ForwardRef as ReactComponent };